import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';

import {TeamappProvider} from "../../providers/teamapp";

import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
/**
 * Generated class for the RegisterRequestPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-register-request',
  templateUrl: 'register-request.html',
})
export class RegisterRequestPage {

  registerForm: FormGroup;

  name: string;
  surname: string;
  email: string;
  policy: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, public teamappProvider: TeamappProvider, public alertCtrl: AlertController) {

    this.registerForm = this.formBuilder.group({
        name: ['', Validators.required],
        surname: ['', Validators.required],
        email: ['', Validators.required],
        policy: [false, Validators.required]
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RegisterRequestPage');
  }

  submitRegister() {
      this.teamappProvider.http_request('action=request_account&register_name='+this.name+'&register_surname='+this.surname+'&register_email='+this.email, 'account', false, true).then(data => {

          console.log(data);
          const alert = this.alertCtrl.create({
              title: 'Erfolgreich!',
              subTitle: '!',
              buttons: ['OK']
          });
          alert.present();
          this.navCtrl.pop();
      });
  }

  openPrivacy() {
      this.navCtrl.push(PrivacyPolicyPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/register-request/register-request.ts